import { useSyncExternalStore } from 'react';
import { detectPlatform, type DesktopPlatform, type PlatformHints } from './detectPlatform.ts';

// Hệ điều hành không đổi trong một phiên xem ⇒ không có gì để đăng ký nghe.
const subscribe = () => () => undefined;

function readClient(): DesktopPlatform | null {
  // `userAgentData` chưa có trong `lib.dom`; đọc qua kiểu hẹp thay vì ép `any`.
  const nav: Navigator & Pick<PlatformHints, 'userAgentData'> = navigator;
  return detectPlatform({
    userAgent: nav.userAgent,
    maxTouchPoints: nav.maxTouchPoints,
    ...(nav.userAgentData === undefined ? {} : { userAgentData: nav.userAgentData }),
  });
}

/**
 * Nền tảng của người đang xem, hoặc `null` khi chưa biết / không có bản cài.
 *
 * `useSyncExternalStore` chứ không phải `useState` + effect: bản prerender (SSG) không có
 * `navigator`, nên server snapshot là `null` và React tự render lại bằng giá trị thật SAU hydrate
 * — không lệch markup, và không vướng luật `react-hooks/set-state-in-effect`.
 */
export function useDesktopPlatform(): DesktopPlatform | null {
  return useSyncExternalStore(subscribe, readClient, () => null);
}
